var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"rounded-circle",attrs:{"src":_vm.image,"width":"25px"}})}
var staticRenderFns = []

export { render, staticRenderFns }